import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import _Tooltip from "@material-ui/core/Tooltip";
import { View } from "@codeArt/components/html/View";
import { type } from "@codeArt/utils/common";
import { Explorer } from "@codeArt/components/explorer/index";

const useStylesBootstrap = makeStyles(theme => ({
  arrow: {
    color: theme.palette.common.black
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    padding: "0.4rem 0.7rem",
    borderRadius: "0.15rem"
  }
}));

const BootstrapTooltip = React.forwardRef((props, ref) => {
  const classes = useStylesBootstrap();
  return <_Tooltip arrow ref={ref} classes={classes} {...props} />;
});

export default function Tooltip({ description, content, placement, props, key }) {
  if (!description) return content;
  let title =
    type(description) === "string" ? (
      <View
        textClassName="mb-0 c-text-s1d5 text-white font-weight-normal"
        html={Explorer.processHTML(description)}
        {...props}
      />
    ) : (
      description
    );
  return (
    <BootstrapTooltip key={key} title={title} placement={placement} {...props}>
      {content}
    </BootstrapTooltip>
  );
}

Tooltip.defaultProps = {
  placement: "top"
};
